var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 12.5,
    fill: "white",
    stroke: "#7DCC18"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4494 13.0597C30.2812 12.8914 30.0533 12.7969 29.8154 12.7969C29.5776 12.7969 29.3496 12.8914 29.1815 13.0597L20.8555 21.3857L17.9054 18.4355C17.679 18.2091 17.3488 18.1207 17.0394 18.2035C16.7301 18.2865 16.4885 18.528 16.4055 18.8374C16.3227 19.1468 16.4111 19.4769 16.6376 19.7033L20.2216 23.2874C20.3898 23.4557 20.6177 23.5502 20.8556 23.5502C21.0934 23.5502 21.3214 23.4557 21.4895 23.2874L30.4495 14.3274C30.6178 14.1593 30.7123 13.9313 30.7123 13.6935C30.7123 13.4557 30.6178 13.2276 30.4495 13.0596L30.4494 13.0597Z",
    fill: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5147 18.8872C30.4506 18.5735 30.224 18.3177 29.9205 18.2163C29.6167 18.1149 29.282 18.1832 29.0423 18.3955C28.8027 18.6079 28.6945 18.9319 28.7584 19.2455C29.1276 21.0483 28.8692 22.9231 28.026 24.5587C27.1827 26.1943 25.8053 27.4923 24.1227 28.2371C22.44 28.982 20.5532 29.129 18.7755 28.6535C16.9978 28.1782 15.4361 27.1092 14.3499 25.6239C13.2635 24.1385 12.7178 22.3263 12.8033 20.4883C12.8889 18.65 13.6007 16.8964 14.8204 15.5187C16.04 14.1407 17.6943 13.2213 19.5084 12.9132C21.3226 12.6051 23.1876 12.9268 24.794 13.8247C25.074 13.9816 25.4164 13.9771 25.6924 13.813C25.9683 13.6488 26.1357 13.3501 26.1315 13.0289C26.1273 12.708 25.9521 12.4136 25.672 12.2568C23.7842 11.1994 21.6008 10.7928 19.4588 11.0996C17.3169 11.4063 15.3351 12.4094 13.8199 13.9542C12.3048 15.4989 11.3399 17.4994 11.0745 19.647C10.809 21.7945 11.2576 23.9698 12.3512 25.837C13.4446 27.7042 15.1223 29.1597 17.1252 29.9786C19.128 30.7978 21.3444 30.935 23.4332 30.3693C25.5218 29.8035 27.3662 28.5661 28.6816 26.8482C29.9971 25.1301 30.7107 23.0269 30.7121 20.863C30.7118 20.1995 30.6458 19.5377 30.515 18.8873L30.5147 18.8872Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderConfirm);
export default __webpack_public_path__ + "static/media/header-confirm.7ae4b28e205823598c7a8137be334466.svg";
export { ForwardRef as ReactComponent };